import p1Img from "../assets/p1.png";
import p2Img from "../assets/p2.png";
import p3Img from "../assets/p3.png";

export const products = [
  {
    id: "p1",
    name: "Zidărie",
    img: p1Img,
  },
  {
    id: "p2",
    name: "BCA",
    img: p2Img,
  },
  {
    id: "p3",
    name: "Tencuială",
    img: p3Img,
  },
];

export const dimensions = {
  BCA: [
    "599 x 50 x 199",
    "599 x 75 x 199",
    "599 x 200 x 199",
    "599 x 100 x 199",
    "599 x 150 x 199",
    "600 x 200 x 200",
    "600 x 250 x 200",
    "600 x 300 x 200",
    "620 x 200 x 240",
    "620 x 150 x 240",
    "625 x 200 x 240",
    "625 x 250 x 240",
    "625 x 300 x 240",
    "650 x 200 x 240",
  ],
  CARAMIDA: [
    "230 x 114 x 64",
    "240 x 115 x 88",
    "240 x 115 x 63",
    "250 x 300 x 238",
    "250 x 300 x 249",
    "250 x 120 x 65",
    "290 x 110 x 217",
    "290 x 140 x 88",
    "290 x 240 x 128",
    "290 x 240 x 238",
    "364 x 200 x 238",
    "365 x 180 x 138",
    "365 x 200 x 188",
    "375 x 145 x 217",
    "375 x 250 x 238",
    "375 x 250 x 249",
    "500 x 200 x 238",
  ],
  BOLTAR: [
    "400 x 125 x 195",
    "500 x 300 x 195",
    "500 x 200 x 195",
    "500 x 200 x 250",
    "500 x 120 x 238",
  ],
};
